/* global VXConfig */
import PropTypes                      from "prop-types";
import Constants                      from "../../flux/Constants";
import React                          from "react";
import Flux                           from "../../flux/Flux";
import { generateKey } from "../../utils/CommonUtils";

const DOT_POSITION = {
	INSIDE: 'inside',
	OUTSIDE: 'outside',
};

const DOT_STYLE = {
	EQUAL: 'equal',
	DYNAMIC: 'dynamic',
};

const ARROW_POSITION = {
	HALF: 'half',
	INSIDE: 'inside',
};

const CONTROL_VISIBILITY = {
	HOVER: 'hover',
	ALWAYS: 'always',
	HIDDEN: 'hidden'
};

const PAGINATION_POSITION = {
	LEFT:  'left',
	RIGHT: 'right'
};

const DEFAULT_PADDING   = 30;
const DEFAULT_GRID_GAP  = 30;
const DEFAULT_SUB_PIXEL = 60;

class Slider extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			maxContainerWidth: this.props.maxContainerWidth,
			maxTileWidth:      1200,
			gridControls:      this.props.challenges.map(() => false),
			currentSlide:      this.props.initIndex,
			subPixel:          this.getSubPixel(),
			isFixedWidth:      this.props.maxTileWidth,
			wrapperWidth:      '100vw',
			isChallengeWrapper: false,
		};

		this.slider       = null;
		this.lastTab      = null;
		this.isMouseEnter = false;
		this.touchStart;
		this.tabTimer;

		this.wrapper         = React.createRef();
		this.grid            = React.createRef();
		this.handleScroll    = this.handleScroll.bind(this);
		this.windowResize    = this.windowResize.bind(this);
		this.setGridControl  = this.setGridControl.bind(this);
		this.setWrapperWidth = this.setWrapperWidth.bind(this);
		this.onTouchStart    = this.onTouchStart.bind(this);
		this.onTouchEnd      = this.onTouchEnd.bind(this);
		this.onTouchMove     = this.onTouchMove.bind(this);
		this.clickNext       = this.clickNext.bind(this);
		this.clickBack       = this.clickBack.bind(this);
		this.handleKeyDown   = this.handleKeyDown.bind(this);
		this.onMouseEnter    = this.onMouseEnter.bind(this);
		this.onMouseLeave    = this.onMouseLeave.bind(this);
	}

	componentDidMount() {
		this.setGridControl(this.props.initIndex);
		this.windowResize(true);
		Flux.Browser.addWindowResizeListener(this.windowResize);
		document.addEventListener('keydown', this.handleKeyDown);
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.isOverlay !== this.props.isOverlay || (this.props.challengeWrapper && this.props.challengeWrapper.current.clientWidth && this.props.challengeWrapper.current.clientWidth + 'px' !== prevState.wrapperWidth)) {
			this.setWrapperWidth(() => {
				this.handleScroll(true);
			});
		}
		if (this.props.challengeWrapper && !this.state.isChallengeWrapper && !this.state.isFixedWidth) {
			this.setWrapperWidth();
		}
	}

	componentWillUnmount() {
		Flux.Browser.removeWindowResizeListener(this.windowResize);
		document.removeEventListener('keydown', this.handleKeyDown);
	}

	handleKeyDown(e) {
		if (this.isMouseEnter || this.props.useKeyNav) {
			switch(e.which) {
				case 39:
					this.clickNext();
					break;
				case 37:
					this.clickBack();
					break;
			}
		}
	}

	onMouseEnter() {
		this.isMouseEnter = true;
	}

	onMouseLeave() {
		this.isMouseEnter = false;
	}

	isMobile() {
		return this.props.isMobile || Flux.Browser.getWindowSize().width  < this.props.mobileBreakpoint;
	}

	windowResize(isInit = false){
		const challengeWrapper = this.props.challengeWrapper;
		let wrapperWidth       = this.state.wrapperWidth;
		let maxContainerWidth  = this.state.maxContainerWidth;
		let isChallengeWrapper = this.state.isChallengeWrapper;
		if (challengeWrapper) {
			wrapperWidth       = `${challengeWrapper.current.clientWidth}px`;
			isChallengeWrapper = true;

			if (this.props.themeConfig.showMessenger && VXConfig.guestIsLoggedIn) {
				maxContainerWidth = 1300 + (Flux.Browser.getWindowSize().width - challengeWrapper.current.clientWidth);
			}
		}

		this.setState({subPixel: this.getSubPixel(), wrapperWidth, maxContainerWidth, isChallengeWrapper}, () => {
			if (this.wrapper && this.wrapper.current) {
				this.handleScroll(isInit);
			}
		});
	}

	handleScroll(isInit = false){
		if (isInit) {
			this.slideTo(this.state.currentSlide, "instant");
			return;
		}
		const width     = this.getTileWidth();
		const tileWidth = this.state.isFixedWidth ? this.getFixedWidhtTileWidth() : (width < this.state.maxContainerWidth ? (width - this.state.subPixel) : (this.state.maxTileWidth - this.state.subPixel)) ;
		const tolerance = this.state.isFixedWidth ? this.state.isFixedWidth : 100;
		const wrapper   = Math.abs(this.wrapper.current.scrollLeft - (this.isMobile() ? this.getPadding() : 0));

		if (this.state.isFixedWidth) {
			const tileNumber = Math.floor(wrapper / (tileWidth));
			if(this.state.currentSlide !== tileNumber) {
				this.setGridControl(tileNumber);
			}
		} else if((wrapper % (tileWidth) > (tileWidth - tolerance) || (wrapper % tileWidth)) < tolerance) {
			const tileNumber = Math.floor(wrapper / (tileWidth));
			if(this.state.currentSlide !== tileNumber) {
				this.setGridControl(tileNumber);
			}
		}
	}

	getConfig(challenge) {
		const { title, subTitle, description } = challenge;
		return  {
			backgroundContent: true,
			description: {
				title,
				subTitle,
				description,
			},
		};
	}

	getFixedWidhtTileWidth() {
		if (this.isFixedContainerWidth()) {
			return 3.5 * this.state.isFixedWidth;
		} else {
			return 2 * this.state.isFixedWidth;
		}
	}

	slideTo(index, behavior = "smooth") {
		const wrapper   = this.wrapper.current;
		const width     = this.getTileWidth();
		const tileWidth = this.state.isFixedWidth ? this.getFixedWidhtTileWidth() : (width < this.state.maxContainerWidth ? (width - this.state.subPixel) : (this.state.maxTileWidth - this.state.subPixel));
		const slideTo   = this.props.isFullWidth ? (index * tileWidth) : (index * (tileWidth) + (index * this.getGridGap() || 1) - (this.isMobile() && index === 0 ? 10 : 0));
		wrapper.scrollTo({left: slideTo, behavior});
	}

	isFixedContainerWidth() {
		return Flux.Browser.getWindowSize().width > this.state.maxTileWidth;
	}

	setGridControl(index) {
		if (this.state.isFixedWidth) {
			const fixedGridControlls = [];
			const multiplicator = this.isFixedContainerWidth() ? 3 : 1.25;
			const fixedGrids    = (Math.floor((this.isFixedContainerWidth() ? this.state.maxTileWidth : (Flux.Browser.getWindowSize().width  - 100)) / (this.state.isFixedWidth * multiplicator)));

			for(let i = 0; i < fixedGrids; i++) {
				fixedGridControlls.push(false);
			}
			fixedGridControlls[index] = true;
			this.setState({
				gridControls: fixedGridControlls,
				currentSlide: index,
			});
		} else {
			const gridControls  = this.props.challenges.map(() => false);
			gridControls[index] = true;
			this.setState({
				gridControls,
			}, () => {
				setTimeout(() => {
					this.setState({currentSlide: index});
				}, 0);
			});
		}
		if (typeof this.props.onIndexChange === 'function') {
			this.props.onIndexChange(index);
		}
	}

	setWrapperWidth(callback) {
		const challengeWrapper = this.props.challengeWrapper;
		let wrapperWidth       = this.state.wrapperWidth;
		let maxContainerWidth  = this.state.maxContainerWidth;
		if (challengeWrapper) {
			wrapperWidth = `${challengeWrapper.current.clientWidth}px`;
			if (this.props.themeConfig.showMessenger && VXConfig.guestIsLoggedIn) {
				maxContainerWidth = 1300 + (Flux.Browser.getWindowSize().width - challengeWrapper.current.clientWidth);
			}
		}

		this.setState({wrapperWidth, maxContainerWidth, isChallengeWrapper: true}, () => {
			callback && callback();
		});
	}

	getTileWidth() {
		const windowWidth  = Flux.Browser.getWindowSize().width;
		const wrapperWidth = this.props.challengeWrapper ? this.props.challengeWrapper.current.clientWidth : 115;
		return this.props.themeConfig.showMessenger && VXConfig.guestIsLoggedIn && (this.props.maxTileWidth < 1) ? windowWidth - (windowWidth - wrapperWidth) : windowWidth ;
	}

	clickBack() {
		this.state.currentSlide > 0 && this.slideTo(this.state.currentSlide - 1);
	}

	clickNext() {
		this.state.currentSlide < this.state.gridControls.length - 1 && this.slideTo(this.state.currentSlide + 1);
	}

	getPadding() {
		if (this.props.isFullWidth) {
			return 0;
		}

		if (typeof this.props.padding === 'number') {
			return this.props.padding;
		}

		return DEFAULT_PADDING;
	}

	getGridGap() {
		if (this.props.isFullWidth) {
			return 0;
		}

		if (typeof this.props.gridGap === 'number') {
			return this.props.gridGap;
		}

		return DEFAULT_GRID_GAP;
	}

	getSubPixel() {
		if (this.props.isFullWidth) {
			return 0;
		}

		if (typeof this.props.subPixel === 'number') {
			return this.props.subPixel;
		}

		const width      = this.getTileWidth();
		const isMaxWidth = (this.props.maxTileWidth > 0) ? false : (width >= this.props.maxContainerWidth);
		return this.isMobile() ? DEFAULT_SUB_PIXEL : (isMaxWidth ? 0 : 100);
	}

	onTouchMove() {
		clearTimeout(this.tabTimer);
	}

	onTouchStart(e) {
		this.touchStart   = e.touches[0].clientX;
		const secondTouch = e.touches[1];

		if (secondTouch) {
			clearTimeout(this.tabTimer);
			return;
		}

		if (this.props.onDoubleTouch) {
			const date        = new Date();
			const time        = date.getTime();
			const timeBetween = this.props.doubleTime;

			if (time - this.lastTab < timeBetween) {
				if (typeof this.props.onDoubleTouch === 'function') {
					this.props.onDoubleTouch();
				}
				clearTimeout(this.tabTimer);
				return;
			}

			this.lastTab = time;
		}

		if (e.touches[0].target.classList.contains('-icon-single-arrow-left-line') || e.touches[0].target.classList.contains('-icon-single-arrow-right-line')) {
			return;
		}

		this.tabTimer = setTimeout(() => {
			if (typeof this.props.onTouch === 'function') {
				this.props.onTouch();

			}
		}, this.props.doubleTime);
	}

	onTouchEnd(e) {
		const touchEnd = e.changedTouches[0].clientX;
		if (this.touchStart > touchEnd + 30) {
			this.clickNext();
		} else if (this.touchStart < touchEnd - 30) {
			this.clickBack();
		}
	}


	getArrowBaseClass() {
		const show   = (this.isMobile() && this.props.arrows.mobile.show === CONTROL_VISIBILITY.ALWAYS) || (!this.isMobile() && this.props.arrows.desktop.show === CONTROL_VISIBILITY.ALWAYS) ||
						(this.props.isTablet && this.props.arrows.tablet.show === CONTROL_VISIBILITY.ALWAYS);
		const hover  = (this.isMobile() && this.props.arrows.mobile.show === CONTROL_VISIBILITY.HOVER) || (!this.isMobile() && this.props.arrows.desktop.show === CONTROL_VISIBILITY.HOVER);
		let position = "";

		if (this.isMobile()) {
			position = this.props.arrows.mobile.position;
		} else {
			position = this.props.arrows.desktop.position;
		}

		return (show ? "vxslider__arrow--show" : "") + (hover ? " vxslider__arrow--hover" : "") + " vxslider__arrow--" + position;
	}


	getBackArrow() {
		if ((this.state.currentSlide === 0) ||
			(this.isMobile() && this.props.arrows.mobile.show === CONTROL_VISIBILITY.HIDDEN) ||
			(this.props.isTablet && this.props.arrows.tablet.show === CONTROL_VISIBILITY.HIDDEN) ||
			(!this.isMobile() && this.props.arrows.desktop.show === CONTROL_VISIBILITY.HIDDEN)) {
			return null;
		}

		return  <div onClick={this.clickBack}
					 className={"vxslider__arrow vxslider__arrow--left " + this.getArrowBaseClass()}>
						<i className={"icon -icon-single-arrow-left-line"}></i>
				</div>;
	}

	getNextArrow() {
		if ((this.state.currentSlide >= this.state.gridControls.length - 1) ||
			(this.isMobile() && this.props.arrows.mobile.show === CONTROL_VISIBILITY.HIDDEN) ||
			(this.props.isTablet && this.props.arrows.tablet.show === CONTROL_VISIBILITY.HIDDEN) ||
			(!this.isMobile() && this.props.arrows.desktop.show === CONTROL_VISIBILITY.HIDDEN)) {
			return null;
		}

		return <div onClick={this.clickNext}
					className={"vxslider__arrow vxslider__arrow--right " + this.getArrowBaseClass()}>
					<i className={"icon -icon-single-arrow-right-line"}></i>
				</div>;
	}

	getPagination() {
		if ((this.props.challenges.length < 2) ||
			this.isMobile() && this.props.pagination.mobile.show === CONTROL_VISIBILITY.HIDDEN ||
			this.props.isTablet && this.props.pagination.tablet.show === CONTROL_VISIBILITY.HIDDEN ||
			!this.isMobile() && this.props.pagination.desktop.show === CONTROL_VISIBILITY.HIDDEN) {
			return null;
		}

		const show  = (this.isMobile() && this.props.pagination.mobile.show === CONTROL_VISIBILITY.ALWAYS) || (this.props.isTablet && this.props.pagination.tablet.show === CONTROL_VISIBILITY.ALWAYS) || (!this.isMobile() && this.props.pagination.desktop.show === CONTROL_VISIBILITY.ALWAYS);
		const hover = (this.isMobile() && this.props.pagination.mobile.show === CONTROL_VISIBILITY.HOVER) || (!this.isMobile() && this.props.pagination.desktop.show === CONTROL_VISIBILITY.HOVER);
		const position = this.isMobile() ? this.props.pagination.mobile.position : (this.props.isTablet ? this.props.pagination.tablet.position : this.props.pagination.desktop.position);

		return <div className={"vxslider__pagination" + (show ? " vxslider__pagination--show" : "") + (hover ? " vxslider__pagination--hover" : "") + (" vxslider__pagination--" + position)}>
			{this.state.currentSlide + 1} / {this.props.challenges.length}
		</div>;
	}

	getDots() {
		if (!this.props.showControls ||
			this.props.challenges.length < 2 ||
			this.isMobile() && this.props.dots.mobile.show === CONTROL_VISIBILITY.HIDDEN ||
			this.props.isTablet && this.props.dots.tablet.show === CONTROL_VISIBILITY.HIDDEN ||
			!this.isMobile() && this.props.dots.desktop.show === CONTROL_VISIBILITY.HIDDEN) {
				return null;
		}

		const isDot = (index) => {
			if (this.isMobile() && this.props.dots.mobile.style === DOT_STYLE.DYNAMIC || !this.isMobile() &&  this.props.dots.desktop.style === DOT_STYLE.DYNAMIC) {
				const current = this.state.currentSlide;
				if (current === 0) {
					switch (index) {
					case 0:
					case current + 1:
					case current + 2: {
						return "lg";
					}
					case current + 3: {
						return "md";
					}
					case current + 4: {
						return "sm";
					}
					default: {
						return "none";
					}
					}
				} else if (current === this.props.challenges.length - 1) {
					switch (index) {
					case this.props.challenges.length - 1:
					case current - 1:
					case current - 2: {
						return "lg";
					}
					case current - 3: {
						return "md";
					}
					case current - 4: {
						return "sm";
					}
					default: {
						return "none";
					}
					}
				} else {
					switch (index) {
					case current:
					case current + 1:
					case current - 1: {
						return "lg";
					}
					case current + 2:
					case current - 2: {
						return "md";
					}
					case current + 3:
					case current - 3: {
						return "sm";
					}
					default: {
						return "none";
					}
					}
				}
			}

			return "lg";
		};

		const onDotClick = (currentImage) => {
			clearTimeout(this.tabTimer);
			this.slideTo(currentImage);
		};

		let position = '';

		if (this.isMobile()) {
			position = this.props.dots.mobile.position;
		} else {
			position = this.props.dots.desktop.position;
		}

		const show  = (this.isMobile() && this.props.dots.mobile.show === CONTROL_VISIBILITY.ALWAYS) || (this.props.isTablet && this.props.dots.tablet.show === CONTROL_VISIBILITY.ALWAYS) || (!this.isMobile() && this.props.dots.desktop.show === CONTROL_VISIBILITY.ALWAYS);
		const hover = (this.isMobile() && this.props.dots.mobile.show === CONTROL_VISIBILITY.HOVER) || (!this.isMobile() && this.props.dots.desktop.show === CONTROL_VISIBILITY.HOVER);

		return (
			<div className={"vxslider__dot-wrapper vxslider__dot-wrapper--" + position + (show ? " vxslider__dot-wrapper--show" : "") + (hover ? " vxslider__dot-wrapper--hover" : "") }>
				{this.props.challenges.map((item, index) => (
					<div
						className={"vxslider__dot vxslider__dot--" + isDot(index) + (index === this.state.currentSlide ? " vxslider__dot--active" : "")}
						key={generateKey(index)}
						onClick={() => onDotClick(index)}
					></div>
				))}
			</div>
		);
	}

	getNavigation() {
		return <React.Fragment>
			{this.getPagination()}
			{this.getBackArrow()}
			{this.getNextArrow()}
			{this.getDots()}
		</React.Fragment>;
	}

	setSlider(ref) {
		if (ref && (ref.clientWidth - 100) !== this.state.maxTileWidth) {
			this.setState({maxTileWidth: (ref.clientWidth - 100)});
		}
	}

	render() {
		if(!this.state.gridControls) {
			return false;
		}

		const sliderContent = this.props.sliderContent;
		const challenges    = this.props.challenges;
		const width         = this.getTileWidth();
		const tileWidth     = this.props.maxTileWidth ? this.props.maxTileWidth + 'px' : ((width < this.state.maxContainerWidth) ? this.state.wrapperWidth : this.state.maxTileWidth + 'px');
		const gridColums    = this.props.maxTileWidth ? (`repeat(${challenges.length}, ${this.props.maxTileWidth}px)`) : (`repeat(${challenges.length}, calc(${tileWidth} - ${this.state.subPixel}px)`);

		if(sliderContent.length < 1) {
			return <div></div>;
		}
		return (
			<div className={"vxslider" + this.props.additionalClass}
					ref={ref => this.setSlider(ref)}
					onTouchStart={this.onTouchStart}
					onTouchEnd={this.onTouchEnd}
					onTouchMove={this.onTouchMove}
					onMouseEnter={this.onMouseEnter}
					onMouseLeave={this.onMouseLeave}>
				<div className={"vxslider__wrapper" + (!this.props.useSwipe ? " vxslider__wrapper--hidden" : " vxslider__wrapper--scroll-x")} onScroll={() => this.handleScroll()} ref={this.wrapper} id="slider-wrapper">
					<div className={"vxslider__grid"} ref={this.grid} style={{gridTemplateColumns: gridColums, padding: this.getPadding() + 'px', gridGap: this.getGridGap() + 'px'}}>
						{sliderContent}
					</div>
				</div>
				{this.getNavigation()}
			</div>
		);
	}
}
const CONTROL_VISIBILITY_ARRAY  = Object.values(CONTROL_VISIBILITY);
const PAGINATION_POSITION_ARRAY = Object.values(PAGINATION_POSITION);
const DOT_POSITION_ARRAY        = Object.values(DOT_POSITION);
const DOT_STYLE_ARRAY           = Object.values(DOT_STYLE);
const ARROW_POSITION_ARRAY      = Object.values(ARROW_POSITION);

const DEVICE_DOTS_CONFIG = {
	show:     PropTypes.oneOf(CONTROL_VISIBILITY_ARRAY),
	position: PropTypes.oneOf(DOT_POSITION_ARRAY),
	style:	  PropTypes.oneOf(DOT_STYLE_ARRAY)
};
const DEVICE_PAGINATION_CONFIG = {
	show:     PropTypes.oneOf(CONTROL_VISIBILITY_ARRAY),
	position: PropTypes.oneOf(PAGINATION_POSITION_ARRAY),
};
const DEVICE_ARROWS_CONFIG = {
	show:     PropTypes.oneOf(CONTROL_VISIBILITY_ARRAY),
	position: PropTypes.oneOf(ARROW_POSITION_ARRAY),
};

Slider.propTypes = {
	challenges:          PropTypes.array,
	hasAVS:              PropTypes.bool,
	teams:               PropTypes.array,
	themeConfig:         PropTypes.object,
	sliderContent:       PropTypes.array,
	maxTileWidth:        PropTypes.number,
	showControls:        PropTypes.bool,
	challengeWrapper:    PropTypes.object,
	onIndexChange:       PropTypes.func,
	padding:             PropTypes.number,
	gridGap:             PropTypes.number,
	mobileBreakpoint:    PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	isMobile:            PropTypes.bool,
	subPixel:            PropTypes.number,
	initIndex:           PropTypes.number,
	maxContainerWidth:   PropTypes.number,

	isFullWidth:         PropTypes.bool,
	useSwipe:            PropTypes.bool,
	onTouch:             PropTypes.func,
	onDoubleTouch:       PropTypes.func,
	doubleTime:          PropTypes.number,
	useKeyNav:           PropTypes.bool,
	isOverlay:           PropTypes.bool,
	isTablet:            PropTypes.bool,



	additionalClass:     PropTypes.string,
	pagination:          PropTypes.shape({
		styleClass: PropTypes.string,
		mobile:     PropTypes.shape(DEVICE_PAGINATION_CONFIG),
		tablet: 	PropTypes.shape(DEVICE_PAGINATION_CONFIG),
		desktop: 	PropTypes.shape(DEVICE_PAGINATION_CONFIG)
	}),
	dots: PropTypes.shape({
		styleClass: PropTypes.string,
		mobile: 	PropTypes.shape(DEVICE_DOTS_CONFIG),
		tablet:  	PropTypes.shape(DEVICE_DOTS_CONFIG),
		desktop: 	PropTypes.shape(DEVICE_DOTS_CONFIG)
	}),
	arrows:                PropTypes.shape({
		styleClass: PropTypes.string,
		mobile: 	PropTypes.shape(DEVICE_ARROWS_CONFIG),
		tablet: 	PropTypes.shape(DEVICE_ARROWS_CONFIG),
		desktop: 	PropTypes.shape(DEVICE_ARROWS_CONFIG)
	})
};

Slider.defaultProps = {
	showControls:        true,
	onIndexChange:       null,
	isMobile:            false,
	mobileBreakpoint:    Constants.Grid2.BREAKPOINT_MIN_WIDTHS.md,
	isFullWidth:         false,
	useSwipe:            false,
	onTouch:             null,
	onDoubleTouch:       null,
	doubleTime:          200,
	useKeyNav:           false,
	initIndex:           0,
	maxContainerWidth:   1300,
	maxTileWidth:        0,
	isOverlay:           false,
	isTablet:            false,

	additionalClass:    '',
	pagination:     {
		styleClass:     '',
		mobile: {
			show:       CONTROL_VISIBILITY.HIDDEN,
			position:   PAGINATION_POSITION.RIGHT
		},
		tablet: {
			show:       CONTROL_VISIBILITY.HIDDEN,
			position:   PAGINATION_POSITION.RIGHT
		},
		desktop: {
			show:       CONTROL_VISIBILITY.HIDDEN,
			position:   PAGINATION_POSITION.RIGHT
		}
	},
	dots:                {
		styleClass:     '',
		mobile: {
			show:       CONTROL_VISIBILITY.ALWAYS,
			position:   DOT_POSITION.OUTSIDE,
			style:		DOT_STYLE.EQUAL,
		},
		tablet: {
			show:       CONTROL_VISIBILITY.HIDDEN,
			position:   DOT_POSITION.OUTSIDE,
			style:		DOT_STYLE.EQUAL
		},
		desktop: {
			show:       CONTROL_VISIBILITY.HIDDEN,
			position:   DOT_POSITION.OUTSIDE,
			style:		DOT_STYLE.EQUAL
		}
	},
	arrows:                {
		styleClass:     '',
		mobile: {
			show:       CONTROL_VISIBILITY.HIDDEN,
			position:   ARROW_POSITION.HALF,
		},
		tablet: {
			show:       CONTROL_VISIBILITY.ALWAYS,
			position:   ARROW_POSITION.HALF,
		},
		desktop: {
			show:       CONTROL_VISIBILITY.ALWAYS,
			position:   ARROW_POSITION.HALF,
		}
	}
};

export default Slider;

export {
	DOT_POSITION,
	DOT_STYLE,
	ARROW_POSITION,
	CONTROL_VISIBILITY,
	PAGINATION_POSITION
};
